import axios from 'axios';
import { IArtFilters } from '../../redux/state/artworksState';
import { artworkFields } from '../../util/artwork/artworkFields';

export const fetchArtworks = (limit: number = 50, offset: number = 0, order: string = "", orient: string = "asc", filters: IArtFilters) => {
    let url = `/api/v1/artwork?source=cp&limit=${limit}&offset=${offset}&order=${order}&orient=${orient}&term[isInactive]=0`;

    for (let key in filters) {
        if (key == "mainSearch") {
            continue;
        }
        if (key === "account_id") {
            url += `&${key}=${filters[key]}`;
        } else if (filters[key].length && Array.isArray(filters[key]) && key == "statusName") {
            filters[key].forEach(el => {
                url += `&termIn[${key}][]=${el}`
            });
        } else {
            if (["identity", "designNo", "orderNum"].indexOf(key) != -1) {
                if (filters["mainSearch"] == "")
                    url += `&term[${key}]=${filters[key]}`;
            } else {
                url += `&term[${key}]=${filters[key]}`;
            }
        }
    }
    if (filters["mainSearch"] != "") {
        url += `&search=${filters["mainSearch"]}`;
    }
    return axios.get(url);
};

export const fetchArtwork = (artworkId: string) => axios.get(`/api/v1/artwork/${artworkId}`);

export const updateArtwork = (artworkId: string, statusId: string) => axios.put(`/api/v1/artwork/${artworkId}`, { statusId });

export const updateAnyKeyArtwork = (artworkId: string, data) =>
    axios.put(`/api/v1/artwork/${artworkId}`, data);
